module.exports = __webpack_public_path__ + "img/direction-down.a5def953.svg";